import React, { useRef, useState } from "react";
import { useParams } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import { useWindowSize } from "../../../../../Helpers";
import Button from "@components/Button";
import "./style.scss";
import LinearGradientProgressBar from "@components/LinearGradientProgressBar";
import StickyButton from "../../../../../components/StickyButton";
import PagesHeader from "@components/PagesHeader";
import StickyContent from "@components/StickyContent";
import BrandLogo from "@components/BrandLogo";
import NiceModal from "@ebay/nice-modal-react";
import DOMPurify from "dompurify";

export default function RevealImageQuiz({
  currentQuestion,
  setCurrentQuestion,
  setAnswers,
  answers,
  sendAnswers,
}) {
  const { ident } = useParams();
  const { width } = useWindowSize();
  const queryClient = useQueryClient();
  const gameQuestionsQuery = queryClient.getQueryData([
    "game-questions",
    ident,
  ]);
  const XGA = width >= 1020;
  const [userBoard, setUserBoard] = useState([]);
  const [board, setBoard] = useState([]);

  if (userBoard.length === 0) {
    setUserBoard([...gameQuestionsQuery.content[currentQuestion].answers]);
  }

  const handleNextButtonClick = () => {
    setAnswers((prev) => [
      ...prev,
      {
        question_ident: `q${currentQuestion}`,
        answer_ident: userBoard.map((e) => e.ident),
      },
    ]);

    setCurrentQuestion(1);
  };

  function succesedAnswer(ident) {
    setBoard([ident, ...board]);
  }

  const handleTileClick = (element) => {
    if (board.includes(element.ident)) {
      return;
    } else {
      NiceModal.show("reveal-image-quiz-modal", {
        question: element.question,
        correctAnswer: element.correctAnswer,
        onSuccess: () => succesedAnswer(element.ident),
      });
    }
  };

  console.log("answers", answers);

  return (
    <section className={`game-page reveal-image-quiz-mechanics ${ident}`}>
      <div>
        <PagesHeader back>
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(gameQuestionsQuery?.title),
            }}
          ></p>
        </PagesHeader>
        <div className="main-game-wrppaer">
          <div className="desktop-wrapper">
            <div className="upper-section">
              <LinearGradientProgressBar value={board.length / 6} />
            </div>
            <div className="game-question">
              <h2
                className="question"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(gameQuestionsQuery.content[currentQuestion].question),
                }}
              />
            </div>
          </div>
          <div className="side-img">
            <BrandLogo brands={gameQuestionsQuery?.brands} />
            <div className="board">
              {userBoard.length !== 0 &&
                userBoard.map((element, index) => (
                  <img
                    data-index={index}
                    className="tile"
                    src={
                      board.includes(element?.ident)
                        ? element?.img
                        : gameQuestionsQuery?.unrevealImg
                    }
                    alt=""
                    key={index}
                    draggable={false}
                    onClick={() => handleTileClick(element)}
                  />
                ))}
            </div>
            {XGA && (
              <StickyContent>
                <div className="desktop-buttons">
                  <Button
                    disabled={
                      board.length <
                      gameQuestionsQuery?.content[currentQuestion].correctAnswer
                        .length
                    }
                    action={handleNextButtonClick}
                  >
                    {gameQuestionsQuery.content[currentQuestion]
                      .nextButtonCopy ?? "Nächste"}
                  </Button>
                </div>
              </StickyContent>
            )}
          </div>
          {!XGA && (
            <StickyButton
              disabled={
                board.length <
                gameQuestionsQuery?.content[currentQuestion].correctAnswer
                  .length
              }
              action={handleNextButtonClick}
            >
              {gameQuestionsQuery.content[currentQuestion]
                .nextButtonCopy ?? "Nächste"}
            </StickyButton>
          )}
        </div>
      </div>
    </section>
  );
}
